import { ContextMenuButton } from '@/components/form/baseInputs/Button/ContextMenuButton';
import { useFeedback } from '@/components/notifications/Feedback/useFeedback';
import { MenuItem } from '@/components/poppers/MenuPopper/MenuItem';
import { useCopyToClipboard } from '@/hooks/useCopyToClipboard';
import { useCurrentUser } from '@/modules/authentication/hooks/useCurrentUser';
import { CreateTenantSlideConfigInput } from '@/types/schema';

export function InternalSlideMenu({
  config,
  onOpenSettings,
}: {
  config: CreateTenantSlideConfigInput | undefined;
  onOpenSettings?: () => void;
}) {
  const user = useCurrentUser();
  const [copyToClipboard] = useCopyToClipboard();
  const { showFeedback } = useFeedback();

  const canCopyJSON = Boolean(user?.isInternalUser && config);
  if (!canCopyJSON && !onOpenSettings) return null;

  const copyJSON = () => {
    if (!config) return;
    const { configType, slideIdentifier, contentJSON, displayName, isHidden } =
      config;
    copyToClipboard(
      JSON.stringify(
        { configType, slideIdentifier, contentJSON, displayName, isHidden },
        null,
        2
      ),
      () => showFeedback('Saved slide JSON copied', { variant: 'success' }),
      () => showFeedback('Failed to copy slide JSON', { variant: 'error' })
    );
  };

  return (
    <ContextMenuButton
      variant="transparent"
      size="sm"
      aria-label="Education page actions"
    >
      {canCopyJSON && <MenuItem label="Copy saved JSON" onClick={copyJSON} />}
      {onOpenSettings && (
        <MenuItem label="Page settings" onClick={onOpenSettings} />
      )}
    </ContextMenuButton>
  );
}
